export default __webpack_public_path__ + "static/media/e2.05e6a743.jpg";